//Обрезаем текст и ставим троеточие (4 строчки, если больше, то троеточие)
function clampText() {
    const myParagraph = $('.clamp-text');

    myParagraph.each(function (index, element) {
        $clamp(element, { clamp: 4 })
    });
}
